var _rect, _path, _rect2, _path2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.10986,
    y: 1,
    width: 11.0711,
    height: 2.52632,
    rx: 1.26316,
    fill: "#757A88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.57895L1.71485 3.3079C1.83246 3.42783 2.02562 3.42783 2.14324 3.3079L4.4065 1",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.10986,
    y: 12.7891,
    width: 11.0711,
    height: 2.52632,
    rx: 1.26316,
    fill: "#757A88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.368L1.71485 15.097C1.83246 15.2169 2.02562 15.2169 2.14324 15.097L4.4065 12.7891",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.10986,
    y: 6.89355,
    width: 11.0711,
    height: 2.52632,
    rx: 1.26316,
    fill: "#757A88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0774 9.41987L3.55485 6.89355M1 6.89355L3.55487 9.41987",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIconMobile);
export default __webpack_public_path__ + "static/media/test_icon-mobile.62a3f773940fcfd6359272ba22c422b5.svg";
export { ForwardRef as ReactComponent };